module.exports = __webpack_public_path__ + "assets/img/fr-651cd9e5.png";